export default __webpack_public_path__ + "static/media/gmv.b634ee97.svg";